import {Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {Toggle} from '../../../../../libs/shared/ui/src/components/booleanInputs/toggle';
import {isTeamNamespace} from '../../../../helpers/models/namespaceHelpers';
import {ChannelSmoochModel} from '../../../../models/api/channelModel';
import {InboxModel} from '../../../../models/api/inboxModel';
import {SettingsInboxesUrl} from '../../../../models/url/settingsUrlModel';
import {SettingsFieldLine} from '../../../common/settingsFieldLine';
import {
  ChannelAutoAssignField,
  ChannelReplyControlField,
  ChannelUndoSendTimingField,
  SettingsCommonChannelFieldProps,
} from '../settingsCommonChannelFields';

/*
 * Props.
 */

interface SettingsChannelSmoochFieldsProps extends SettingsCommonChannelFieldProps<ChannelSmoochModel> {
  inbox: InboxModel;
  url: SettingsInboxesUrl;
}

/*
 * Component.
 */

export const SettingsChannelSmoochFields: FC<SettingsChannelSmoochFieldsProps> = (props) => {
  const {edited, setDirty, onChange, onPreferencesChange} = props;
  const isSharedChannel = isTeamNamespace(props.edited.namespace);

  return (
    <div>
      <ChannelUndoSendTimingField
        edited={edited}
        setDirty={setDirty}
        onChange={onChange}
        onPreferencesChange={onPreferencesChange}
      />
      {isSharedChannel && (
        <ChannelReplyControlField
          edited={edited}
          onChange={onChange}
          onPreferencesChange={onPreferencesChange}
          setDirty={setDirty}
        />
      )}
      <ChannelAutoAssignField
        edited={edited}
        onChange={onChange}
        onPreferencesChange={onPreferencesChange}
        setDirty={setDirty}
      />
      <SettingsFieldLine
        title={<Trans id="settingschannel-importwhispers">Import whisper messages in Front</Trans>}
        content={
          <Toggle
            isChecked={edited.preferences.importWhispers}
            onChange={(newValue) => {
              onPreferencesChange({
                importWhispers: newValue,
              });
            }}
          />
        }
      />
    </div>
  );
};
